import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = () => {
  return {
    id: null,
    external_id: null,
    agreementDate: null,
    jumiaId: null,
    firstName: null,
    lastName: null,
    profile_picture: null,
    birthday: null,
    phoneNumberCode: null,
    phoneNumber: null,
    gender: null,
    locationId: null,
    jforceTypeId: null,
    jforceTypeName: null,
    stateId: null,
    timeslotId: null,
    timeslotName: null,
    stateName: null,
    recruitmentChannelId: null,
    locationName: null,
    recruitmentChannel: null,
    email: null,
    levelId: null,
    jforce_agreement: null,
    sales_experience: null,
    trained: null,
    own_store: null,
    kraPin: null,
    account_type: null,
    geo_location: null,
    is_relative_in_jumia: null,
    tax_id_number: null,
    id_card_number: null,
    id_card_picture: null,
    store_type: null,
    store_name: null,
    store_photo: null,
    address: null,
    is_convicted: null,
    updated_jforce_agreement: null,
    updated_jforce_agreement_content: null,
    updated_jforce_agreement_pdf: null,
    status: null,
    subject_id: null,
    signature: null,

    phoneNumberError: false,
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    systemError: false,

    isAuth: null,
    isJForce: null,
    isInactive: null,
    isPaymentMethodMandatory: null,
    acceptedTermsAndCondition: null,
    paymentMethodNeedConfirmation: null,
    hasPaymentMethod: null,
    mandatoryPaymentMethod: null,

    userUpdating: false,

    availablePaymentMethods: null,
    availablePaymentMethodsError: false,
    availablePaymentMethodsLoading: false,

    paymentMethods: null,
    paymentMethodsError: false,
    paymentMethodsLoading: false,

    paymentMethod: null,
    paymentMethodError: false,
    paymentMethodLoading: false,

    locations: [],
    locationError: false,
    locationLoading: false,

    cities: [],
    citiesError: false,
    citiesLoading: false,

    banks: [],
    banksError: false,
    banksLoading: false,

    recruitmentChannels: [],
    recruitmentChannelsLoading: false,
    recruitmentChannelsError: false,

    networks: [],
    networkList: [],
    networksLoading: false,
    networksError: false,

    timeSlots: [],
    timeSlotsLoading: false,
    timeSlotsError: false,

    languages: [],
    languageList: [],
    languagesLoading: false,
    languagesError: false,

    jforceTypes: [],
    jforceTypesLoading: false,
    jforceTypesError: false,
    isImpersonate: false,
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
